export default __webpack_public_path__ + "static/media/O-118.6ee3b247.png";